import React, { useState, useEffect, useCallback } from 'react';
import { useNotification } from '../context/NotificationContext';
import './UserFormModal.css';

function CompSetFormModal({ isOpen, onClose, onCompSetSaved, editingCompSet }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { showNotification } = useNotification();

    useEffect(() => {
        if (editingCompSet) {
            setName(editingCompSet.name);
            setDescription(editingCompSet.description || '');
        } else {
            setName('');
            setDescription('');
        }
    }, [editingCompSet, isOpen]);

    const getAuthHeader = useCallback(() => {
        const token = localStorage.getItem('token');
        return token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : {};
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name) {
            setError('El nombre del comp set es obligatorio.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const isEditMode = !!editingCompSet;
        const path = isEditMode ? `compsets/${editingCompSet.comp_set_id}` : 'compsets';
        const url = `${process.env.REACT_APP_API_URL}/api.php?path=${path}`;
        const method = isEditMode ? 'PUT' : 'POST';

        try {
            const response = await fetch(url, {
                method: method,
                headers: getAuthHeader(),
                body: JSON.stringify({ name, description })
            });

            const result = await response.json();
            if (response.ok && result.success) {
                showNotification(result.data.message || 'Operación exitosa!', 'success');
                onCompSetSaved();
                onClose();
            } else {
                throw new Error(result.error?.message || 'Ocurrió un error desconocido.');
            }
        } catch (err) {
            setError(err.message);
            showNotification(err.message, 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) { return null; }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{editingCompSet ? 'Editar Comp Set' : 'Agregar Nuevo Comp Set'}</h2>
                    <button onClick={onClose} className="close-button">&times;</button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        {error && <p className="error-message">{error}</p>}
                        <div className="form-group">
                            <label htmlFor="compset-name">Nombre del Comp Set</label>
                            <input type="text" id="compset-name" value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="compset-description">Descripción (Opcional)</label>
                            <textarea 
                                id="compset-description" 
                                rows="3" 
                                value={description} 
                                onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="cancel-btn" onClick={onClose} disabled={isSubmitting}>Cancelar</button>
                            <button type="submit" className="submit-btn" disabled={isSubmitting}>
                                {isSubmitting ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CompSetFormModal;